import Admin from "../Admin";
import React from "react";
import CardAdminBaseUnitTypeList from "../../../Component/Card/Admin/BaseUnitType/CardAdminBaseUnitTypeList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class AdminBaseUnitTypeList extends Admin {
  /**
   * Render the content.
   */
  renderContent() {
    return <CardAdminBaseUnitTypeList />;
  }

  renderHeader() {
    const handleClickCreate = () => {
      this.props.history.push({
        pathname: "/admin/baseUnitType",
      });
    };

    const buttons = [
      <MUIButton
        component="label"
        variant="contained"
        startIcon={<MUIAddIcon />}
        onClick={handleClickCreate}
      >
        Create New
      </MUIButton>,
    ];

    return <PageHeader title="Base Unit Types" buttons={buttons} />;
  }
}
